export const queryKeys = {
  countries: ['countries'],
  countryStates: (countryId) => ['countries', countryId, 'states'],
  industries: ['industries'],
  jobLevels: ['jobLevels'],
  allSkills: ['skills', 'all'],
  jobs: (page, limit, filters) => ['jobs', page, limit, filters || {}],
  myJobs: (page, limit) => ['myJobs', page, limit],
  notifications: ['notifications'],
  wbLeague: ['wbLeague'],
  recruiterOwn: ['recruiterOwn'],
  experts: ['experts'],
  expertCategories: ['expertCategories'],
  jobSeekerSubscription: ['jobSeekerSubscription'],
  activeCampaign: ['activeCampaign'],
  jobSeekerPlans: ['jobSeekerPlans'],
  profile: ['profile'],
  proHunterTrial: ['proHunterTrial'],
  communityPosts: (page) => ['communityPosts', page],
  postComments: (postId) => ['postComments', postId],
};
